import * as React from 'react';

const Heater = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={34} height={35} fill={color}>
    <g clipPath="url(#a)">
      <path d="M20.188 26.695a3.188 3.188 0 1 1-4.25-3.007V5.445a1.062 1.062 0 1 1 2.124 0v18.243a3.189 3.189 0 0 1 2.125 3.007Z" />
      <path d="M11.688 5.445a5.312 5.312 0 1 1 10.624 0V21.49a7.437 7.437 0 1 1-10.625 0V5.445ZM17 2.258a3.188 3.188 0 0 0-3.188 3.187v16.973l-.354.318a5.313 5.313 0 1 0 7.082 0l-.352-.318V5.445A3.187 3.187 0 0 0 17 2.258Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 .133h34v34H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Heater;
